import React, {useState} from "react";
import ChevronDown from "react-feather/dist/icons/chevron-down";

import PostCard from "../PostCard/PostCard";
import PostCardLink from "../PostCardLink/PostCardLink";
import "./BlogGallery.scss";

const Masonry = ({cols = 3, children}) => {
  const columnWrapper = {};
  const result = [];
  for (let i = 0; i < cols; i += 1) {
    columnWrapper[`column${i}`] = [];
  }
  for (let i = 0; i < children.length; i += 1) {
    const columnIndex = i % cols;
    columnWrapper[`column${columnIndex}`].push(<div>{children[i]}</div>);
  }
  for (let i = 0; i < cols; i += 1) {
    result.push(
      <div
        style={{
          flex: 1,
        }}
      >
        {columnWrapper[`column${i}`]}
      </div>
    );
  }
  return <div style={{display: "flex"}}>{result}</div>;
};

const BlogGallery = ({data, post_type: postType = "normal"}) => {
  const [pageLength, setPageLength] = useState(12);
  return (
    <div className='gallery-wrap mb-12 px-4 md:px-0'>
      <div className='gallery desktop'>
        <Masonry>
          {data.map((post, i) => {
            if (i < pageLength) {
              if (!post.featured && postType === "home") {
                return postType === "link" ? (
                  <PostCardLink data={post} />
                ) : (
                  <PostCard data={post} />
                );
              }
              return postType === "link" ? (
                <PostCardLink data={post} />
              ) : (
                <PostCard data={post} />
              );
            }
            return undefined;
          })}
        </Masonry>
      </div>
      <div className='gallery mobile'>
        <Masonry cols={1}>
          {data.map((post, i) => {
            if (i < pageLength) {
              if (!post.featured && postType === "home") {
                return postType === "link" ? (
                  <PostCardLink data={post} />
                ) : (
                  <PostCard data={post} />
                );
              }
              return postType === "link" ? (
                <PostCardLink data={post} />
              ) : (
                <PostCard data={post} />
              );
            }
            return undefined;
          })}
        </Masonry>
      </div>
      {pageLength < data.length ? (
        <div
          className='show-more p-4 my-12 inline-block rounded-md mx-auto flex flex-row items-center'
          onClick={() => {
            setPageLength(pageLength + 12);
          }}
        >
          <p>Show more posts</p>
          &ensp;
          <ChevronDown />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default BlogGallery;
